if (!customElements.get('free-offer')) {
    class FreeOffer extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        let total = parseInt(this.dataset.cartTotal, 10);
        let freeShippingMinimum = Math.round(
          parseInt(this.dataset.freeShippingMinimum, 10) * (Shopify.currency.rate || 1)
        );
        let freeProductMinimum = Math.round(
          parseInt(this.dataset.freeProductMinimum, 10) * (Shopify.currency.rate || 1)
        );
  
        // Elements for Free Shipping
        this.remainingTextShipping = this.querySelector(
          '.free-offer--text-remaining-shipping'
        );
        this.fullTextShipping = this.querySelector('.free-offer--text-full-shipping');
        let percentageShipping = 1;
  
        // Elements for Free Product
        this.remainingTextProduct = this.querySelector(
          '.free-offer--text-remaining-product'
        );
        this.fullTextProduct = this.querySelector('.free-offer--text-full-product');
        let percentageProduct = 1;
  
        // Handle Free Shipping Condition
        if (total < freeShippingMinimum) {
          percentageShipping = total / freeShippingMinimum;
  
          let remainingShipping = freeShippingMinimum - total;
          let format =
            window.theme.settings.money_with_currency_format || '${{amount}}';
          this.remainingTextShipping.innerHTML = formatMoney(
            remainingShipping,
            format
          );
  
          this.remainingTextShipping.style.display = 'block';
          this.fullTextShipping.style.display = 'none';
        } else {
          this.remainingTextShipping.style.display = 'none';
          this.fullTextShipping.style.display = 'block';
        }
  
        // Handle Free Product Condition
        if (total < freeProductMinimum) {
          percentageProduct = total / freeProductMinimum;
  
          let remainingProduct = freeProductMinimum - total;
          let format =
            window.theme.settings.money_with_currency_format || '${{amount}}';
          this.remainingTextProduct.innerHTML = formatMoney(
            remainingProduct,
            format
          );
  
          this.remainingTextProduct.style.display = 'block';
          this.fullTextProduct.style.display = 'none';
        } else {
          this.remainingTextProduct.style.display = 'none';
          this.fullTextProduct.style.display = 'block';
        }
  
        // Update Progress Bars
        this.style.setProperty('--percentage-shipping', percentageShipping);
        this.style.setProperty('--percentage-product', percentageProduct);
      }
    }
    customElements.define('free-offer', FreeOffer);
  }
  